export default function TechHeroSection() {
  return (
    <section className="relative min-h-[75vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/2eefb0528009bdc199f97340e8a9e8c6.jpg"
          alt="Functional Textile Technology"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 lg:px-8 text-center">
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-8" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
          Functional Textile & Workwear
        </h1>
        <p className="text-xl md:text-2xl text-white/95 max-w-3xl mx-auto leading-relaxed">
          첨단 소재 기술로 산업 현장의 안전과 편안함을 지킵니다
        </p>
      </div>
    </section>
  );
}